import React, {PropsWithChildren} from 'react';
import VisualToggleContextProvider from './VisualToggleContext';
import VisualContextProvider from './VisualContext';
import LengthUnitContextProvider from './LengthUnitContext';

const DimensionsContext = ({children}: PropsWithChildren) => {
  return (
    <LengthUnitContextProvider>
      <VisualContextProvider>
        <VisualToggleContextProvider>{children}</VisualToggleContextProvider>
      </VisualContextProvider>
    </LengthUnitContextProvider>
  );
};

export default DimensionsContext;
